//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Color from 'color';
import { Chrome } from 'vue-color';
import ClickOutside from '@/directives/ClickOutside';
import Tooltip from '@/mixins/tooltip';
import DpIcon from '../icon/Icon.vue';

export default {
  name: 'DpColourBox',
  directives: { ClickOutside },
  components: {
    'chrome-picker': Chrome,
    DpIcon,
  },
  mixins: [Tooltip],
  props: {
    value: { type: String, default: null },
    isBase: { type: Boolean, default: false },
    locked: { type: Boolean, default: false },
  },
  data() {
    return {
      displayPicker: false,
      colourValue: '',
      colours: {
        hex: '#ffffff',
      },
    };
  },
  computed: {
    lockIconColour() {
      if (!this.colourValue) {
        return '#333';
      }

      const lum = Color(this.colourValue).luminosity();
      if (lum > 0.3) {
        return '#333';
      }
      return '#fff';
    },
  },
  watch: {
    colourValue(val, old) {
      if (val) {
        this.updateColours(val);
      } else {
        this.colours = null;
        this.colourValue = null;
      }
      if (val !== old && old !== null && old !== '') {
        this.$emit('input', val);
        this.$emit('change', val);
      }
    },
    value(val) {
      this.setColour(val);
    },
  },
  mounted() {
    this.setColour(this.value);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updatePickerPosition, true);
  },
  methods: {
    setColour(colour) {
      if (!colour) {
        return;
      }
      this.updateColours(colour);
      this.colourValue = colour;
    },
    updateColours(colour) {
      if (colour.slice(0, 1) === '#') {
        this.colours = {
          hex: colour,
        };
      } else if (colour.slice(0, 4) === 'rgba') {
        const rgbaColour = Color(colour);
        const hex = rgbaColour.hex().string();
        this.colours = {
          hex,
        };
      }
    },
    showPicker() {
      this.displayPicker = true;
      this.updatePickerPosition();
      window.addEventListener('scroll', this.updatePickerPosition, true);
    },
    hidePicker() {
      this.displayPicker = false;
      window.removeEventListener('scroll', this.updatePickerPosition, true);
    },
    togglePicker() {
      if (this.displayPicker) {
        this.hidePicker();
      } else {
        this.showPicker();
      }
    },
    updateFromInput() {
      this.updatecolours(this.colourValue);
    },
    updateFromPicker(colour) {
      this.colours = colour;
      if (!this.displayAsRgb) {
        this.colourValue = colour.hex;
      } else {
        this.colourValue = `rgb(${colour.rgba.r}, ${colour.rgba.g}, ${colour.rgba.b})`;
      }
    },
    updatePickerPosition() {
      if (!this.$refs.picker || !this.$el) return;

      const heightOffset = -5;
      const heightCheckSize = 280;
      const containerPos = this.$el.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const xPos = containerPos.top + containerPos.height;

      // Check the direction
      if (xPos + heightCheckSize > windowHeight) {
        // Dropdown above
        this.$refs.picker.style.bottom = `${windowHeight - containerPos.top - heightOffset}px`;
        this.$refs.picker.style.top = 'auto';
      } else {
        // Dropdown below
        this.$refs.picker.style.top = `${xPos - heightOffset}px`;
        this.$refs.picker.style.bottom = 'auto';
      }

      this.$refs.picker.style.left = `${containerPos.left - 70}px`;
    },
  },
};
